import { useServices } from "../app/services.ts";
import type { StoredMessage } from "../data/store.ts";
import { useStore } from "../data/store.ts";
import { MapView } from "./MapView.tsx";
import styles from "./Location.module.css";

/** A place or a live location in the chat, with a small map. */
export function LocationCard({ message, mine, senderName }: { message: StoredMessage; mine: boolean; senderName: string }) {
  const services = useServices();
  const r = message.response;
  const place = message.content.place;
  const live = r.live;
  const position = useStore((s) => s.positions.get(r.id));
  const point = live ? position : place && place.lat !== undefined && !place.live ? { lat: place.lat, lon: place.lon } : undefined;
  const until = live?.ends_at ? new Date(live.ends_at).toLocaleTimeString("de-AT", { hour: "2-digit", minute: "2-digit" }) : null;
  const title = live ? (live.active ? `Live-Standort${until ? ` · bis ${until}` : ""}` : "Live-Standort beendet") : (place?.label ?? (place?.place ? "Ort" : "Standort"));
  return (
    <div className={styles.card}>
      <div className={styles.mini}>
        {point ? <MapView pins={[{ id: r.id, lat: point.lat, lon: point.lon, color: live ? "#2fb344" : "#e03131", label: senderName }]} center={[point.lat, point.lon]} zoom={15} interactive={false} /> : <span>{live?.active ? "Wartet auf die erste Position …" : ""}</span>}
      </div>
      <div className={styles.cardText}>
        <b>📍 {title}</b>
        {point && (
          <a href={`https://www.openstreetmap.org/?mlat=${point.lat}&mlon=${point.lon}#map=17/${point.lat}/${point.lon}`} target="_blank" rel="noopener noreferrer">
            In OpenStreetMap öffnen
          </a>
        )}
        {live?.active && mine && (
          <button className={styles.stop} onClick={() => void services.stopLiveLocation(r.id)}>
            Teilen beenden
          </button>
        )}
        {live?.active && mine && !services.sharing.has(r.id) && <small>Wird in einem anderen Fenster oder Gerät geteilt.</small>}
      </div>
    </div>
  );
}
